import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { BookBrowser } from "@/components/catalog/book-browser";
import { LibraryHome } from "@/components/catalog/library-home";
import { Page } from "@/components/page";
import { SelectionProvider } from "@/components/shelves/selection";
import {
  type BookSearch,
  bookSearchSchema,
  facetsQuery,
  isUnrefinedSearch,
  recentBooksQuery,
} from "@/lib/catalog";

export const Route = createFileRoute("/_app/_library/")({
  validateSearch: bookSearchSchema,
  component: LibraryPage,
});

function LibraryPage() {
  const { t } = useTranslation("catalog");
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const { data: recent } = useQuery(recentBooksQuery);
  const { data: facets } = useQuery(facetsQuery);
  const unrefined = isUnrefinedSearch(search);
  return (
    <SelectionProvider>
      <Page
        title={t("title")}
        description={
          recent && facets && recent.total > 0
            ? t("home.summary", {
                books: t("home.books", { count: recent.total }),
                languages: t("home.languages", { count: facets?.languages.length ?? 0 }),
              })
            : undefined
        }
      >
        <BookBrowser
          intro={unrefined ? <LibraryHome /> : null}
          libraryRoot
          selectable
          smartShelf
          search={search}
          onSearchChange={(patch: Partial<BookSearch>) =>
            void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: "q" in patch })
          }
        />
      </Page>
    </SelectionProvider>
  );
}
